export default __webpack_public_path__ + "static/erp-1a1841217660c19f6e4f4037611ec9f1.svg";